module.exports = __webpack_public_path__ + "static/media/ss-mobile-2-mockup.d25dda4f.png";